import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './locales/en/common.json';
import taCommon from './locales/ta/common.json';
import deCommon from './locales/de/common.json';
import frCommon from './locales/fr/common.json';
import esCommon from './locales/es/common.json';
import zhCommon from './locales/zh/common.json';
import jaCommon from './locales/ja/common.json';
import nlCommon from './locales/nl/common.json';
import ruCommon from './locales/ru/common.json';
import enNav from './locales/en/nav.json';
import taNav from './locales/ta/nav.json';
import deNav from './locales/de/nav.json';
import frNav from './locales/fr/nav.json';
import esNav from './locales/es/nav.json';
import zhNav from './locales/zh/nav.json';
import jaNav from './locales/ja/nav.json';
import nlNav from './locales/nl/nav.json';
import ruNav from './locales/ru/nav.json';
import enSettings from './locales/en/settings.json';
import taSettings from './locales/ta/settings.json';
import deSettings from './locales/de/settings.json';
import frSettings from './locales/fr/settings.json';
import esSettings from './locales/es/settings.json';
import zhSettings from './locales/zh/settings.json';
import jaSettings from './locales/ja/settings.json';
import nlSettings from './locales/nl/settings.json';
import ruSettings from './locales/ru/settings.json';
import enNotifications from './locales/en/notifications.json';
import taNotifications from './locales/ta/notifications.json';
import deNotifications from './locales/de/notifications.json';
import frNotifications from './locales/fr/notifications.json';
import esNotifications from './locales/es/notifications.json';
import zhNotifications from './locales/zh/notifications.json';
import jaNotifications from './locales/ja/notifications.json';
import nlNotifications from './locales/nl/notifications.json';
import ruNotifications from './locales/ru/notifications.json';
import enDashboard from './locales/en/dashboard.json';
import enWelcome from './locales/en/welcome.json';
import taWelcome from './locales/ta/welcome.json';
import enHelp from './locales/en/help.json';
import enResearch from './locales/en/research.json';
import taHelp from './locales/ta/help.json';
import enOnboarding from './locales/en/onboarding.json';
import taOnboarding from './locales/ta/onboarding.json';
import deOnboarding from './locales/de/onboarding.json';
import frOnboarding from './locales/fr/onboarding.json';
import esOnboarding from './locales/es/onboarding.json';
import zhOnboarding from './locales/zh/onboarding.json';
import jaOnboarding from './locales/ja/onboarding.json';
import nlOnboarding from './locales/nl/onboarding.json';
import ruOnboarding from './locales/ru/onboarding.json';
import { SUPPORTED_LOCALE_CODES } from './supported-languages';

/**
 * i18next configuration — English default; active language driven by user preference when logged in.
 */
i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      nav: enNav,
      settings: enSettings,
      notifications: enNotifications,
      onboarding: enOnboarding,
      dashboard: enDashboard,
      welcome: enWelcome,
      help: enHelp,
      research: enResearch,
    },
    ta: {
      common: taCommon,
      nav: taNav,
      settings: taSettings,
      notifications: taNotifications,
      onboarding: taOnboarding,
      dashboard: enDashboard,
      welcome: taWelcome,
      help: taHelp,
    },
    de: {
      common: deCommon,
      nav: deNav,
      settings: deSettings,
      notifications: deNotifications,
      onboarding: deOnboarding,
      dashboard: enDashboard,
      welcome: enWelcome,
      help: enHelp,
    },
    fr: {
      common: frCommon,
      nav: frNav,
      settings: frSettings,
      notifications: frNotifications,
      onboarding: frOnboarding,
      dashboard: enDashboard,
      welcome: enWelcome,
      help: enHelp,
    },
    es: {
      common: esCommon,
      nav: esNav,
      settings: esSettings,
      notifications: esNotifications,
      onboarding: esOnboarding,
      dashboard: enDashboard,
      welcome: enWelcome,
      help: enHelp,
    },
    zh: {
      common: zhCommon,
      nav: zhNav,
      settings: zhSettings,
      notifications: zhNotifications,
      onboarding: zhOnboarding,
      dashboard: enDashboard,
      welcome: enWelcome,
      help: enHelp,
    },
    ja: {
      common: jaCommon,
      nav: jaNav,
      settings: jaSettings,
      notifications: jaNotifications,
      onboarding: jaOnboarding,
      dashboard: enDashboard,
      welcome: enWelcome,
      help: enHelp,
    },
    nl: {
      common: nlCommon,
      nav: nlNav,
      settings: nlSettings,
      notifications: nlNotifications,
      onboarding: nlOnboarding,
      dashboard: enDashboard,
      welcome: enWelcome,
      help: enHelp,
    },
    ru: {
      common: ruCommon,
      nav: ruNav,
      settings: ruSettings,
      notifications: ruNotifications,
      onboarding: ruOnboarding,
      dashboard: enDashboard,
      welcome: enWelcome,
      help: enHelp,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: [...SUPPORTED_LOCALE_CODES],
  defaultNS: 'common',
  ns: ['common', 'nav', 'settings', 'notifications', 'onboarding', 'dashboard', 'welcome', 'help'],
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
